module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }